import "./Company.module.css";
import CabecalhoInstitucional from "@/reusable_sections/Header";
import ExcelenciaEmEngenhariaTermica from "./sections/ExcelenciaEmEngenhariaTermica";
import NossaTrajetoria from "./sections/NossaTrajetoria";
import TechnicalContentAndArticles from "./sections/TechnicalContentAndArticles";
import InformativeFooter from "@/reusable_sections/Footer";
export default function CompanyPage() {
  return <div>
      <CabecalhoInstitucional />
      <ExcelenciaEmEngenhariaTermica />
      <NossaTrajetoria />
      <TechnicalContentAndArticles />
      <InformativeFooter />
    </div>;
}